import { useContext, useState } from 'react';
import styled from 'styled-components/macro';
import { CreditsContext } from '@stores/CreditsContext';
import SubmissionCreateNoCredits from '@components/submissions/SubmissionCreateNoCredits';
import SubmissionCreateForm from '@components/submissions/SubmissionCreateForm';

const debug = false;
const SubmissionCreate = () => {
  const { creditsInfo } = useContext(CreditsContext);
  const [status, setStatus] = useState({
    status: null,
    documentId: null,
    score: null,
    documentHash: null,
  });
  debug && console.log('SubmissionCreate | {creditsInfo, status}', creditsInfo, status);

  return (
    <Container>
      <Content>
        { creditsInfo.creditsAvailable || status.status ?
          <SubmissionCreateForm
            status = {status}
            setStatus={setStatus}
          />
          :
          <SubmissionCreateNoCredits /> }
      </Content>
    </Container>
  );
};

export default SubmissionCreate;

const Container = styled.div`
  height: calc(100% - 20px);
  width: calc(100% - 20px);
  padding-left: 5px;
  background-color: ${(p) => p.theme.palette.backgroundPrimary};
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  margin: 20px;
`;
